<ng-container *ngIf="widgetName == 'widget-curva-accesso'">
  <div class="hidden" *ngFor="let month of openToAccessInfo; let i = index">
    <ejs-grid #monthGrid [dataSource]="month.regions" allowExcelExport="true"
     (excelQueryCellInfo)="fixExcelFormat($event)"
    >
      <e-columns>
        <e-column
          field="regionName"
          headerText="REGIONI"
          width="180"
        ></e-column>
        <e-column
          field="forecast"
          headerText="FORECAST %"
          width="140"

        >
        </e-column>
        <e-column
          field="actual"
          headerText="ACTUAL %"
          width="140"

        >
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>
</ng-container>

<ng-container *ngIf="widgetName == 'widget-curva-mercato'|| widgetName == 'widget-curva-economia'">
  <div class="hidden" *ngFor="let month of dataForExport; let i = index">
    <ejs-grid
      #monthGrid
      [dataSource]="month.flatRegions"
      allowExcelExport="true"
      (excelQueryCellInfo)="onExcelQueryCellInfo($event)"
    >
      <e-columns>
        <e-column
          field="regionName"
          headerText="REGIONI"
          width="360"
          [valueAccessor]="customValueAccessor"
        ></e-column>
        <e-column
          field="forecast"
          headerText="FORECAST %"
          width="140"
          [valueAccessor]="customValueAccessor"
        >
        </e-column>
        <e-column
          field="actual"
          headerText="ACTUAL %"
          width="140"
          [valueAccessor]="customValueAccessor"
        >
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>
</ng-container>
